import { render, staticRenderFns } from "./RegistrationTest.vue?vue&type=template&id=1d849c97&"
import script from "./RegistrationTest.vue?vue&type=script&lang=js&"
export * from "./RegistrationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports